import Axios from 'axios'
import _ from 'lodash'

export default {
  SET_STATE: (state, payload) => {
    _.set(state, payload.action, payload.data)
  },
  SET_BEARER(state, accessToken) {
    Axios.defaults.headers.common['x-access-token'] = accessToken
  },
  SET_USER_INFO(state, user) {
    state.userInfo = user
  },
  SET_USER_ROLE(state, data) {
    state.userRole = data
  },
  SET_PERMISSIONS(state, permissions) {
    if (!permissions || typeof permissions !== 'object') {
      state.permissionSlugs = []
      return
    }

    try {
      state.permissionSlugs = Object.values(permissions).reduce((per, module) => {
        if (!module || typeof module !== 'object') return per
        const ids = Object.values(module)
          .filter((item) => item && !!item.status)
          .map((item) => item.slug)
        per.push(...ids)
        return per
      }, [])
    } catch (error) {
      state.permissionSlugs = []
    }
  },

  SET_ROLE(state, roles) {
    // state.roles = roles.reduce((acc, role) => {
    //   acc[role.slug] = role.slug // Set the slug as the key and _id as the value
    //   return acc
    // }, {})
  },

  SET_ALL_PERMISSIONS(state, permissions) {
    // Transform the permissions array into an object
    // state.allPermissions = permissions.reduce((acc, permission) => {
    //   acc[permission.slug] = permission._id // Set the slug as the key and _id as the value
    //   return acc
    // }, {})
    // Store permission IDs for easier access if needed
    // state.allPermissionIds = permissions.map((permission) => permission._id)
  }
}
